/** @format */

import React, { useState } from 'react'
import BreadCrumb from '../../../../../Components/BreadCrumb/Index'
import localize from '../../../../../Global/Localize'
import ListSuperSaverPayables from '../Partials/ListSuperSaverPayables/ListSuperSaverPayables'
import { GlobalValidationErrors } from '../../../../../Validation/ValidationState'
import VerifySuperSaverPayable from './VerifySuperSaverPayable/VerifySuperSaverPayable'
import { postData } from '../../../../../Helpers/webApi'
import { showNotification } from '../../../../../Helpers/Notification/ShowNotification'
import { superSaverPayableStatus } from '../../../../../Global/enumeration'
import Swal from 'sweetalert2'

const initialSuperSaverPayable = {
  superSaverPayableAuditOption: 1,
}

const Verification = () => {
  const [reload, setReload] = useState(false)
  const [mode, setMode] = useState(null)
  const [payable, setPayable] = useState(null)
  const [isBusy, setIsBusy] = useState(false)
  const [globalValidationErrors, setGlobalValidationErrors] =
    GlobalValidationErrors.use()

  const handleClickVerify = r => {
    if (r?.status !== Object.keys(superSaverPayableStatus)[0])
      return Swal.fire({
        icon: 'error',
        title: 'Operation not allowed',
        text: 'You can only verify pending Super Saver Payable!',
      })

    setMode('verify')
    setPayable({
      ...initialSuperSaverPayable,
      ...r,
    })
  }

  const clearValidation = column => {
    setGlobalValidationErrors(g => {
      delete g[column]
      return g
    })
  }

  const handleClose = () => {
    setMode(null)
    setPayable(initialSuperSaverPayable)
  }

  const handleVerifySuperSaverPayable = async () => {
    if (!payable.auditRemarks) {
      GlobalValidationErrors.set({
        ...globalValidationErrors,
        AuditRemarks: {
          message: 'Remarks is required',
        },
      })
      return
    }

    setIsBusy(true)

    const url = '/SuperSaverPayable/audit-super-saver-payable'

    const { success } = await postData(
      url,
      {
        superSaverPayable: payable,
        superSaverPayableAuditOption: payable?.superSaverPayableAuditOption,
      },
      false
    )

    if (success) {
      setReload(true)
      handleClose()
      showNotification('Audit Super Saver Payable', 'success')
      setIsBusy(false)
    } else setIsBusy(false)
  }

  return (
    <>
      {mode === 'verify' && (
        <VerifySuperSaverPayable
          clearValidation={clearValidation}
          globalValidationErrors={globalValidationErrors}
          mode={mode}
          handleClose={handleClose}
          superSaverPayable={payable}
          setSuperSaverPayable={setPayable}
          handleVerifySuperSaverPayable={handleVerifySuperSaverPayable}
          loading={isBusy}
        />
      )}

      <BreadCrumb
        tree={[
          localize('frontOfficeManagement'),
          localize('superSaverPayables'),
        ]}
      />

      <div className="card rounded bg-white">
        <div className="card-body">
          <ListSuperSaverPayables
            reload={reload}
            setReload={setReload}
            showVerify
            handleVerify={handleClickVerify}
          />
        </div>
      </div>
    </>
  )
}

export default Verification
